import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    expensesList: [],
    categoriesList: [],
    budgetsList: [],
    selectedExpense: null,
    expenseSummary: null,
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
};

const expenseSlice = createSlice({
    name: "expense",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getExpensesSuccess: (state, action) => {
            state.expensesList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getCategoriesSuccess: (state, action) => {
            state.categoriesList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getBudgetsSuccess: (state, action) => {
            state.budgetsList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getDetailSuccess: (state, action) => {
            state.selectedExpense = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSummarySuccess: (state, action) => {
            state.expenseSummary = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        stuffDone: (state) => {
            state.loading = false;
            state.error = null;
            state.response = null;
            state.statestatus = "added";
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
            state.statestatus = "failed";
        },
        getError: (state, action) => {
            state.loading = false;
            const p = action.payload;
            if (typeof p === "string") {
                state.error = p;
            } else if (p?.response?.data?.message) {
                state.error = p.response.data.message;
            } else if (p?.message) {
                state.error = String(p.message);
            } else {
                state.error = "Request failed";
            }
            state.statestatus = "failed";
        },
        underExpenseControl: (state, action) => {
            const preserveLoading = Boolean(action.payload?.preserveLoading);
            if (!preserveLoading) {
                state.loading = false;
            }
            state.response = null;
            state.error = null;
            state.statestatus = "idle";
        },
    },
});

export const {
    getRequest,
    getExpensesSuccess,
    getCategoriesSuccess,
    getBudgetsSuccess,
    getDetailSuccess,
    getSummarySuccess,
    stuffDone,
    getFailed,
    getError,
    underExpenseControl,
} = expenseSlice.actions;

export const expenseReducer = expenseSlice.reducer;
